<template>
  <b-row>
    <b-col sm="12" md="6" lg="5">
      <b-form-group
          class="d-inline"
          id="select-periodo-form"
          label="*Año"
          label-for="select-mes"
      >
        <b-form-select
            id="select-año"
            v-model="selectedYear"
            :options="periods"
            value-field="anio"
            text-field="anio"
            type="text"
            class="selecterYear"
            @change="updateValue()"
        />
      </b-form-group>
    </b-col>
    <b-col sm="11" md="6" lg="6">
      <b-form-group
          class="d-inline"
          id="select-periodo-form"
          label="Mes"
          label-for="select-mes"
      >
        <b-form-select
            id="select-mes"
            v-model="selectedMonth"
            :options="months"
            value-field="mes"
            text-field="text"
            type="text"
            class="selecterMonth"
            @change="updateMonth()"
        />
      </b-form-group>
    </b-col>
    <b-col lg="1" class="icon">
      <i
          class="hand bx bx-x font-size-24"
          @click="clear"
      />
    </b-col>
  </b-row>
</template>

<script>
import TagPeriodService from "./tagPeriodService";
import moment from "moment";

export default {
  props: {
    patent: String
  },
  data: function () {
    return {
      periods: [],
      selectedMonth: '',
      selectedYear: '',
      months: [],
      meses: [
        { value: "01", text: "Enero", textEn: "January" },
        { value: "02", text: "Febrero", textEn: "February" },
        { value: "03", text: "Marzo", textEn: "March" },
        { value: "04", text: "Abril", textEn: "April" },
        { value: "05", text: "Mayo", textEn: "May" },
        { value: "06", text: "Junio", textEn: "June" },
        { value: "07", text: "Julio", textEn: "July" },
        { value: "08", text: "Agosto", textEn: "August" },
        { value: "09", text: "Septiembre", textEn: "September" },
        { value: "10", text: "Octubre", textEn: "October" },
        { value: "11", text: "Noviembre", textEn: "November" },
        { value: "12", text: "Diciembre", textEn: "December" },
      ]
    }
  },
  mounted () {
    this.firstRequest();
    this.getPeriods();
  },
  methods: {
    getPeriods () {
      let periodRequest;
      periodRequest = TagPeriodService['getPeriodTAGByRut'](this.patent, this.$store.state.rutEmpresa.cuentaSeleccionada.value)
      periodRequest.then((period) => {
        this.periods = period
      })
        .catch(err => console.log(err));
    },
    updateValue () {
      for (let i = 0; i < this.periods.length; i++) {
        if (this.periods[i]["anio"] === this.selectedYear) {
          this.months = this.periods[i]["meses"].map(month => this.$t(`months.${month.mes}`));
        }
      }
    },
    updateMonth () {
      for (let i = 0; i < this.meses.length; i++) {
        if (this.meses[i].text === this.selectedMonth) {
          let date =
              this.selectedYear.toString() +
              "-" +
              this.meses[i].value +
              "-" +
              "01";
          let startDate = moment(date).startOf("month").format("YYYY-MM-DD");
          let endDate = moment(date).endOf("month").format("YYYY-MM-DD");
          this.$emit("change", { fechaDesde: startDate, fechaHasta: endDate });
        }
      }
    },
    firstRequest() {
      this.$emit('change', {"fechaDesde": new Date("2000-01-01"), "fechaHasta": new Date()})
    },
    clear () {
      this.firstRequest()
    }
  },
  watch: {
    patent (newVal) {
      this.getPeriods()
      this.$emit("input", newVal);
      this.$emit("change", {});
    },
  }
}
</script>

<style scoped>
.selecterMonth{
    width: 58%;
}
.selecterYear{
    width: 40%;
    margin-left: 2%;
}
.hand {
  cursor: pointer;
}
.icon {
  margin-left: -25px;
  margin-top: 5px;
}
</style>
